
import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ initialTime, handleLogout }) => {
    const [timeLeft, setTimeLeft] = useState(initialTime);

    useEffect(() => {
        if (timeLeft <= 0) handleLogout(); // Stop if time is up

        const intervalId = setInterval(() => {
            setTimeLeft(prevTime => prevTime - 1);
        }, 1000);

        // Clear interval on component unmount or when timeLeft reaches 0
        return () => clearInterval(intervalId);
    }, [timeLeft]);

    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${String(minutes).padStart(2, '0')}m :${String(seconds).padStart(2, '0')}s`;
    };

    return (
        <div>
            Are you still there? For your safety you will be logged out in {' '}
            <span style={{ fontWeight: 'bold' }}>{formatTime(timeLeft)}</span>, and any unsaved data will be lost. Please click on "Stay Logged-in" button to stay logged-in!
        </div>
    );
};

export default CountdownTimer;


// WEBPACK FOOTER //
// ./src/utils/CountTimer.js